module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Regular-WebS.746561ea.woff";